import { Provider } from "components/sysCategory/SysCategoryContext";
import { SysCategoryList } from "components/sysCategory/SysCategoryList";

export const SysCategories = () => {
    return (
        <Provider>
            <SysCategoryList />
        </Provider>
    );
};
